import $ from 'jquery';

const trackingProductClick = {
    context: $('#masonry-grid'),

    bindEvents() {


        this.context.on('click', '.productcell', function () {
            var $this = $(this);
            var context = $this.closest('.productcell');
            var products = window.impressions;
            var product = $.grep(products, function (e) {
                return e.id == context["0"].id.split("-")[1];
            });
            if (typeof product !== 'undefined' && product.length > 0) {
                dataLayer.push({
                    'event': 'productClick',
                    'ecommerce': {
                        'currencyCode': 'EUR',
                        'click': {
                            'actionField': {'list': product[0].list},
                            'products': [{
                                'id': product[0].id,
                                'name': product[0].name,
                                'price': product[0].price,
                                'brand': product[0].brand,
                                'category': product[0].category,
                                'position': product[0].position
                            }]
                        }
                    },
                });
            }
        });
    }
};

// DOM ready
$(() => {
    if (trackingProductClick.context.length) {
        trackingProductClick.bindEvents();
    }
});

export default trackingProductClick;